import { useAtom } from "jotai";
import { OrderStatus, SortBy } from "../utils/enum";
import { atomWithStorage } from "jotai/utils";

interface Props {
  [key: number]: string;
}

export const defaultValues: Props = {
  [OrderStatus.ARRIVED]: SortBy.PLACED_DATE_TIME,
  [OrderStatus.IN_KITCHEN]: SortBy.PLACED_DATE_TIME,
  [OrderStatus.READY_FOR_DELIVERY]: SortBy.ZIP_CODE,
  [OrderStatus.EN_ROUTE]: SortBy.STATUS,
};

const orderSortAtom = atomWithStorage<Props>("sort", defaultValues);

const useOrderSort = () => {
  const atom = useAtom(orderSortAtom);
  return atom;
};

export const useSetOrderSort = () => useAtom(orderSortAtom);

export default useOrderSort;
